import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import '../../../../assets/css/Ngo/controlpanelCSS/NgoSetting.css';
import NgoLayout from "../../../../layouts/Ngo/NgoLayout";


/* ─────────────────────────────────────────
   Reusable: Toggle Switch
───────────────────────────────────────── */
const ToggleSwitch = ({ checked, onChange }) => (
  <label className="toggle-switch">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span className="toggle-track" />
  </label>
);

/* ─────────────────────────────────────────
   Reusable: Section Card
───────────────────────────────────────── */
const SectionCard = ({ icon, title, children }) => (
  <div className="settings-card">
    <div className="card-header-custom">
      <div className="card-icon">{icon}</div>
      <span className="card-title">{title}</span>
    </div>
    {children}
  </div>
);

/* ─────────────────────────────────────────
   Toast Notification
───────────────────────────────────────── */
const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 2800);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className="toast-notify">
      <span>✓</span>
      {message}
    </div>
  );
};

/* ─────────────────────────────────────────
   Main Settings Component
───────────────────────────────────────── */
export default function Settings({ onBack }) {
  /* Profile */
  const [name, setName]   = useState("Ali Raza");
  const [email, setEmail] = useState("ali@example.com");
  const [phone, setPhone] = useState("");

  /* Password */
  const [currPass, setCurrPass]     = useState("");
  const [newPass, setNewPass]       = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  /* Notifications */
  const [notifEmail, setNotifEmail]   = useState(true);
  const [notifSMS, setNotifSMS]       = useState(false);
  const [notifInApp, setNotifInApp]   = useState(true);

  /* Toast */
  const [toast, setToast] = useState(null);
  const showToast = (msg) => setToast(msg);

  /* Handlers */
  const handleSaveProfile = () => {
    if (!name.trim() || !email.trim()) {
      showToast("⚠ Name and Email are required.");
      return;
    }
    showToast("Profile updated successfully!");
  };

  const handleChangePassword = () => {
    if (!currPass || !newPass || !confirmPass) {
      showToast("⚠ Please fill all password fields.");
      return;
    }
    if (newPass !== confirmPass) {
      showToast("⚠ Passwords do not match.");
      return;
    }
    showToast("Password changed successfully!");
    setCurrPass(""); setNewPass(""); setConfirmPass("");
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      showToast("Logging out…");
    }
  };

  /* Avatar initials */
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <NgoLayout>
    <div className="settings-wrapper">
      <Container>
        {/* ── Header ── */}
        <div className="settings-header">
          <button className="back-btn" onClick={onBack}>
            ← Back to Dashboard
          </button>
          <h1 className="page-title mt-3">
            Set<span>tings</span>
          </h1>
        </div>

        <Row className="g-4">
          {/* ── LEFT COLUMN ── */}
          <Col lg={7}>
            {/* PROFILE */}
            <SectionCard icon="👤" title="Profile">
              {/* Avatar */}
              <div className="avatar-section">
                <div className="avatar-circle">
                  {initials}
                  <span className="avatar-overlay">📷 Change</span>
                </div>
                <div className="avatar-meta">
                  <h6>{name || "Your Name"}</h6>
                  <p>Click avatar to change photo</p>
                </div>
              </div>

              <div className="card-body-custom">
                <Row className="g-3">
                  <Col sm={6}>
                    <div className="field-group">
                      <label className="field-label">Full Name</label>
                      <input
                        className="field-input"
                        type="text"
                        placeholder="Your full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="field-group">
                      <label className="field-label">Email Address</label>
                      <input
                        className="field-input"
                        type="email"
                        placeholder="you@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="field-group">
                      <label className="field-label">Phone Number</label>
                      <input
                        className="field-input"
                        type="tel"
                        placeholder="+92 300 0000000"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <button className="btn-save" onClick={handleSaveProfile}>
                  Save Changes
                </button>
              </div>
            </SectionCard>

            {/* PASSWORD */}
            <SectionCard icon="🔐" title="Password">
              <div className="card-body-custom">
                <Row className="g-3">
                  <Col sm={12}>
                    <div className="field-group">
                      <label className="field-label">Current Password</label>
                      <input
                        className="field-input"
                        type="password"
                        placeholder="••••••••"
                        value={currPass}
                        onChange={(e) => setCurrPass(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="field-group">
                      <label className="field-label">New Password</label>
                      <input
                        className="field-input"
                        type="password"
                        placeholder="••••••••"
                        value={newPass}
                        onChange={(e) => setNewPass(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="field-group">
                      <label className="field-label">Confirm Password</label>
                      <input
                        className="field-input"
                        type="password"
                        placeholder="••••••••"
                        value={confirmPass}
                        onChange={(e) => setConfirmPass(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <button className="btn-password" onClick={handleChangePassword}>
                  Change Password
                </button>
              </div>
            </SectionCard>
          </Col>

          {/* ── RIGHT COLUMN ── */}
          <Col lg={5}>
            {/* NOTIFICATIONS */}
            <SectionCard icon="🔔" title="Notifications">
              <div className="card-body-custom">
                <div className="toggle-row">
                  <div className="toggle-label-wrap">
                    <h6>Email Notifications</h6>
                    <p>Receive updates via email</p>
                  </div>
                  <ToggleSwitch
                    checked={notifEmail}
                    onChange={() => setNotifEmail(!notifEmail)}
                  />
                </div>
                <div className="toggle-row">
                  <div className="toggle-label-wrap">
                    <h6>SMS Notifications</h6>
                    <p>Get alerts on your phone</p>
                  </div>
                  <ToggleSwitch
                    checked={notifSMS}
                    onChange={() => setNotifSMS(!notifSMS)}
                  />
                </div>
                <div className="toggle-row">
                  <div className="toggle-label-wrap">
                    <h6>In-App Notifications</h6>
                    <p>Push notifications in dashboard</p>
                  </div>
                  <ToggleSwitch
                    checked={notifInApp}
                    onChange={() => setNotifInApp(!notifInApp)}
                  />
                </div>
              </div>
            </SectionCard>

            {/* LOGOUT */}
            <SectionCard icon="🚪" title="Session">
              <div className="card-body-custom">
                <p style={{ fontSize: ".82rem", color: "var(--text-muted)", marginBottom: "16px" }}>
                  You will be signed out from all devices and sessions.
                </p>
                <button className="btn-logout" onClick={handleLogout}>
                  <span>⏻</span>
                  Logout
                </button>
              </div>
            </SectionCard>
          </Col>
        </Row>
      </Container>

      {/* Toast Notification */}
      {toast && <Toast message={toast} onClose={() => setToast(null)} />}
    </div>
    </NgoLayout>
  );
}